/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import MenuButton from '../../components/common/menuButton/MenuButton';
import { Grid } from '@mui/material';
import {
  FactoryIcon,
  HolidayVillageIcon,
  HomeWorkIcon,
  HowToRegIcon,
  SafetyDividerIcon,
  GroupsIcon,
} from '../../shared/components/icon';
import { useDialog, useAuth } from '../../shared/context';
import ApproveDialog from '../../components/Dialog/ApproveDialog';
import SectorUserDialog from '../../components/Dialog/SectotUserDialog';
import CreateCoachDialog from '../../components/Dialog/CreateCoachDialog';
import SectorRegistreDialog from '../../components/Dialog/SectorRegistreDialog'; 
import SubSectorRegistreDialog from '../../components/Dialog/SubSectorRegistreDialog';
import LinkSectorSubSectorDialog from '../../components/Dialog/LinkSectorSubSectorDialog';

const GenericDialog = ({ handleClose, handleConfirm, handleCancel, dialogData, ContentComponent }) => (
  <div>
    <ContentComponent handleClose={handleClose} handleConfirm={handleConfirm} handleCancel={handleCancel} dialogData={dialogData} />
  </div>
);

// Array de botões
const buttons = [
  { title: 'Setores', icon: <FactoryIcon color="primary" sx={{ fontSize: '10em' }} />, modal: 'sectorRegistreDialog', ContentComponent: SectorRegistreDialog },
  { title: 'Sub Setores', icon: <HolidayVillageIcon color="primary" sx={{ fontSize: '10em' }} />, modal: 'subSectorRegistreDialog', ContentComponent: SubSectorRegistreDialog },
  { title: 'Vincular Setores e Sub-Setores', icon: <HomeWorkIcon color="primary" sx={{ fontSize: '10em' }} />, modal: 'linkSectorSubSectorDialog', ContentComponent: LinkSectorSubSectorDialog },
  { title: 'Setores Usuários', icon: <SafetyDividerIcon color="primary" sx={{ fontSize: '10em' }} />, modal: 'sectorUserDialog', ContentComponent: SectorUserDialog },
  { title: 'Aprovadores', icon: <HowToRegIcon color="primary" sx={{ fontSize: '10em' }} />, modal: 'approveDialog', ContentComponent: ApproveDialog },
  { title: 'Treinadores', icon: <GroupsIcon color="primary" sx={{ fontSize: '10em' }} />, modal: 'createCoachDialog', ContentComponent: CreateCoachDialog },
];

const Settings = () => {
  const [currentDialog, setCurrentDialog] = useState('');
  const { isDialogOpen, openDialog, closeDialog, dialogData } = useDialog(currentDialog);
  const { checkTokenValidity } = useAuth();

  const handleOpenModal = (button) => {
    setCurrentDialog(button.modal);
  };

  const handleConfirmAction = () => {
    closeDialog();
  };

  const handleCancelAction = () => {
    closeDialog();
  };

  useEffect(() => {
    if (currentDialog) {
      openDialog();
    }
    checkTokenValidity();
    // eslint-disable-next-line
  }, [currentDialog]);

  return (
    <>
      {isDialogOpen() && (
        <GenericDialog
          handleClose={closeDialog}
          handleConfirm={handleConfirmAction}
          handleCancel={handleCancelAction}
          dialogData={dialogData}
          ContentComponent={buttons.find(button => button.modal === currentDialog)?.ContentComponent}
        />
      )}

      <Grid container spacing={2} justifyContent="space-around" alignItems="center">
        {buttons.map((button) => (
          <Grid item key={button.title} xs={12} sm={6} md={4}>
            <MenuButton title={button.title} icon={button.icon} onClick={() => handleOpenModal(button)} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Settings;
